<template>
  <div class="quest-item-list">
    <div v-if="loading">
      <y-progress v-model="progress"></y-progress>
    </div>
    <div name="scroll" class="yxy-fix-safari-overflow-scrolling" :style="{overflow: 'auto', height: pageHeight + 'px'}">
      <div v-if="!followupList.length" style="text-align:center;font-size:16px;height:60px;line-height:60px;">暂无随访</div>
      <cell-arrow-quest
        v-for="item in followupList" :key="item.id"
        :to="{name: 'questlist', param: item.id}"
        :updateTime="item.updateTime"
        :title="item.title">
        <i slot="icon" class="fa fa-file-word-o new"></i>
        <div class="quest-status-percent" slot="progress">
          <y-circle :percent="parseFloat(item.finish * 100)" :trail-width="6" :stroke-width="6" auto-color></y-circle>
        </div>
      </cell-arrow-quest>
      <div style="height: 5px;background: #eee;"></div>
      <group>
        <cell v-for="item in crfList" :key="item.id" :title="item.title">
          <i slot="icon" class="fa fa-qrcode" style="display:block;margin-right:10px;font-size:22px;width:24px;color:#978fff;"></i>
          <span class="add-btn" @click.stop="addFollowup(item)">新增</span>
        </cell>
      </group>
      <informed-consent
        v-model="showConsent"
        title="性功能障碍临床调查知情"
        :content="informedConsent"
        okText="同意"
        cancelText="不同意"
        @on-ok="onOk"
        @on-cancel="onCancel">
      </informed-consent>
    </div>
  </div>
</template>

<script>
import YProgress from './common/y-progress'
import Group from './common/group'
import Cell from './common/cell'
import YCircle from './common/circle'
import CellArrowQuest from './cell-arrow-quest'
import InformedConsent from './informedConsent'
import { getStorageItem, updateStorageItem } from '../utils/cache'
import { authenticate, catchExpired } from '../utils/auth'
import { isMiniProgram } from '../utils/isMiniProgram'

export default {
  components: { YProgress, Group, Cell, YCircle, CellArrowQuest, InformedConsent },
  data () {
    return {
      progress: 0,
      loading: true,
      crfList: [],
      followupList: [],
      informedConsent: '',
      showConsent: false
    }
  },
  computed: {
    pageHeight () {
      return this.$store.getters.getWinHeight
    }
  },
  beforeRouteEnter (to, from, next) {
    document.title = '完成随访'
    next()
  },
  mounted () {
    this.loadInformedConsent()
    this.loadCrfList()
    this.loadFollowupList()
    this.loadAuthInfo()
  },
  methods: {
    onOk () {
      const auth = getStorageItem('auth')
      // 发送请求
      this.$http.post(`${this.httpRoot}/informedConsent/agree`, {
        id: getStorageItem('patientId')
      }, authenticate())
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          auth.agree = true
          updateStorageItem('auth', auth)
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    onCancel () {
      setTimeout(() => {
        if (isMiniProgram()) {
          window.wx.miniProgram.navigateBack()
        } else {
          this.$router.back()
        }
      }, 200)
    },
    loadAuthInfo () {
      this.$http.get(`${this.httpRoot}/patient/info/auth`, authenticate({params: {patientId: getStorageItem('patientId')}}))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success' && res.auth) {
          updateStorageItem('auth', res.auth)
          if (!res.auth.agree) {
            setTimeout(() => {
              this.showConsent = true
            }, 500)
          }
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    loadInformedConsent () {
      this.$http.get(`${this.httpRoot}/informedConsent/detail`, authenticate({params: {id: getStorageItem('patientId')}}))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          this.informedConsent = res.informedConsent
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    loadFollowupList () {
      this.$http.get(`${this.httpRoot}/followup/abstract/list`, authenticate({
        params: {
          patientId: getStorageItem('patientId'),
          subjectId: getStorageItem('subjectId')
        }
      }))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          this.followupList = res.followupList || []
          this.progress = 100
          setTimeout(() => {
            this.loading = false
          }, 50)
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    loadCrfList () {
      this.$http.get(`${this.httpRoot}/crf/abstract/list`, authenticate({
        params: {
          subjectId: getStorageItem('subjectId')
        }
      }))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          this.crfList = res.crfList || []
          setTimeout(() => {
            this.loading = false
          }, 50)
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    addFollowup (item) {
      this.$http.post(`${this.httpRoot}/followup/add/mobile`, {
        patientId: getStorageItem('patientId'),
        subjectId: getStorageItem('subjectId'),
        crfId: item.id,
        title: item.title,
        followupDate: '' + new Date().format('yyyy-MM-dd')
        // followupTimes: null
      }, authenticate())
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          this.loadFollowupList()
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    }
  }
}
</script>

<style lang="less">
.quest-status-percent {
  width: 18px;
  height: 18px;
  margin-left: 5px;
  margin-right: 15px;
  font-size: 14px;
  color: #666;
  &>.yxy-circle {
    display: flex;
  }
}
.add-btn {
  cursor: pointer;
  background-color: #1B9AF7;
  border: 1px solid #1B9AF7;
  border-radius: 2px;
  color: #FFF;
  font-size: 14px;
  padding: 0 16px;
  line-height: 30px;
  box-shadow: 0px 1px 0px #2891ff;
  background: linear-gradient(#34a5f8, #088ef0);
}
</style>
